import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import confianceImg from "../../assets/confiance.jpg";
import proximiteImg from "../../assets/proximite.jpg";
import durabiliteImg from "../../assets/durabilite.jpg";
import transparenceImg from "../../assets/transparence.jpg";

const imageByKey = {
  confiance: confianceImg,
  proximite: proximiteImg,
  durabilite: durabiliteImg,
  transparence: transparenceImg,
};

const ValeurSection = () => {
  const { t } = useTranslation("informations/ValeurSection");

  // Tableau d'items localisés (titre + sous-titre + clé d'image)
  const cards = t("cards", { returnObjects: true });

  return (
    <Box sx={{ display: "flex", justifyContent: "center", px: 2, mt: 10, mb: 10 }}>
      <Box
        sx={{
          maxWidth: "1200px",
          width: "100%",
          fontFamily: "'Poppins', sans-serif",
        }}
      >
        {/* Titre */}
        <Typography
          sx={{
            fontWeight: 900,
            fontSize: { xs: "2.2rem", md: "3.2rem" },
            textAlign: "center",
            mb: 4,
            color: "#000",
          }}
        >
          {t("title.part1")}
          <Box component="span" sx={{ color: "#449F2D" }}> {t("title.highlight")} </Box>
          {t("title.part2")}
        </Typography>

        {/* Cartes */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: 2.5,
            justifyContent: "center",
            flexWrap: "wrap",
            mb: 8,
          }}
        >
          {cards.map((item, index) => (
            <Box
              key={index}
              sx={{
                width: { xs: "100%", sm: 280 },
                maxWidth: "100%",
                height: 340,
                borderRadius: "20px",
                overflow: "hidden",
                position: "relative",
                backgroundImage: `url(${imageByKey[item.key] || confianceImg})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                boxShadow: "0 8px 30px rgba(0, 0, 0, 0.1)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-end",
                mx: "auto",
              }}
            >
              <Box
                sx={{
                  height: "100px",
                  width: "100%",
                  px: 2,
                  pt: 2,
                  background: "linear-gradient(to top, rgba(0,0,0,0.85), rgba(0,0,0,0.4))",
                  color: "#fff",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "1.3rem",
                    fontWeight: 800,
                    textTransform: "uppercase",
                    lineHeight: 1.2,
                    mb: 0.5,
                  }}
                >
                  {item.title}
                </Typography>
                <Typography
                  sx={{
                    fontSize: "0.9rem",
                    lineHeight: 1.3,
                    whiteSpace: "normal",
                    wordWrap: "break-word",
                  }}
                >
                  {item.subtitle}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>

        {/* Paragraphe enrichi */}
        <Typography
          sx={{
            fontSize: "1.15rem",
            fontWeight: 400,
            color: "#444",
            textAlign: "center",
            lineHeight: 1.9,
            maxWidth: "1200px",
            mx: "auto",
          }}
        >
          {t("paragraph.a")} <Box component="span" fontWeight="bold">{t("paragraph.brand")}</Box>, {t("paragraph.b")}{" "}
          <Box component="span" fontWeight="bold">{t("paragraph.foundation")}</Box>. {t("paragraph.c")}{" "}
          <Box component="span" fontWeight="bold">{t("paragraph.trust")}</Box>, {t("paragraph.d")}{" "}
          <Box component="span" fontWeight="bold">{t("paragraph.listening")}</Box>, {t("paragraph.e")}{" "}
          <Box component="span" fontWeight="bold">{t("paragraph.sustainableMobility")}</Box>. {t("paragraph.f")}{" "}
          <Box component="span" fontWeight="bold">{t("paragraph.fullTransparency")}</Box> {t("paragraph.g")}
        </Typography>
      </Box>
    </Box>
  );
};

export default ValeurSection;